HuesMdl.service( 'RedirectSrv', ['$location', 'SITE_URL', function ( $location, SITE_URL ) {

	var redirect_url = false;

	return {
		setRedirect: function() {
			if(redirect_url)
				return;

			redirect_url = $location.search().redirect ? SITE_URL.URL + '/' + $location.search().redirect : false;
		},

		getRedirect: function() {
			return redirect_url;
		}
	}

}]);